module.exports = __webpack_public_path__ + "media/paliwa/u_95@2x-1ef0976f.png";